import store from '../store'

export default {
  install(Vue) {
    Vue.directive('permission', {
      inserted(el, binding) {
        const permission = binding.value
        if (permission) {
          const hasPermission = store.getters.hasPermission(permission)
          if (!hasPermission) {
            // 没有权限，隐藏元素
            el.style.display = 'none'
          }
        }
      },
      update(el, binding) {
        const permission = binding.value
        if (permission) {
          const hasPermission = store.getters.hasPermission(permission)
          if (!hasPermission) {
            // 没有权限，隐藏元素
            el.style.display = 'none'
          } else {
            // 有权限，显示元素
            el.style.display = ''
          }
        }
      }
    })
  }
}